import { Image } from 'react-bootstrap';

export const PortfolioItemCard = ({ title, description, imgUrl }) => {
  return (
      <div className="proj-imgbx">
        <Image src={imgUrl} roundedCorner />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    
  )
}
